module.exports = __webpack_public_path__ + "static/media/logo-dreamturk@3x.1957e61f.png";